import { ApplicationFlowTheme } from '../types'
import { getApplicationFlowTheme } from './application-flow-theme'

interface ChannelPresentationConfig {

  /** 渠道启用状态；只有值为 1 时才允许使用新皮肤。 */
  channelStatus?: unknown

  /** 对客品牌标识；只用于品牌文案与标识展示。 */
  showChannelName?: unknown

  /** 渠道模板；是版本和主题的唯一选择依据。 */
  channelTemplate?: unknown
}

export interface RegisterPresentation {

  /** 解析后的对客品牌名称。 */
  brandName: '聚融易' | '聚好借'

  /** 是否选择聚好借品牌标识的展示变体。 */
  isJhjBrand: boolean

  /** 由渠道模板解析出的主题及其静态资源。 */
  theme: ApplicationFlowTheme
}

/**
 * resolveRegisterPresentation — 将渠道详情安全映射为注册页可消费的展示配置。
 * 仅 channelTemplate 决定是否使用 v2 及其主题，showChannelName 仅决定品牌文案和标识；
 * 当渠道未启用、模板不是 2~6，或品牌字段无效时返回 null，使调用方保持旧皮肤而非猜测展示语义。
 * @param {unknown} detail 渠道详情接口返回的原始数据
 * @returns {RegisterPresentation | null} 有效的 v2 注册展示配置，或表示继续使用旧皮肤的 null
 */
export const resolveRegisterPresentation = (detail: unknown): RegisterPresentation | null => {
  const config = detail && typeof detail === 'object' ? detail as ChannelPresentationConfig : null
  const theme = getApplicationFlowTheme(config?.channelTemplate)

  if (config?.channelStatus !== 1 || !theme) {
    return null
  }
  if (config.showChannelName === 1) {
    return {
      brandName: '聚融易',
      isJhjBrand: false,
      theme,
    }
  }
  if (config.showChannelName === 2) {
    return {
      brandName: '聚好借',
      isJhjBrand: true,
      theme,
    }
  }

  return null
}
